module.exports = __webpack_public_path__ + "static/community-6-ed27a219e9244fe6c125b15406655705.png";